import React from "react";

import Header from "../Templete/Header";
import HeroBanner from "./HeroBanner";
import Footer from "../Templete/Footer";

import PartnersLogo from "./PartnersLogo";
import WhyChooseUs from "./WhyChooseUs";
import Testimonial from "./Testimonial";
import ApiProducts from "./ApiProducts";
import SignupBanner from "./SignupBanner";

const Home = () => {
  return (
    <React.Fragment>
      <Header />
      <HeroBanner />

      <PartnersLogo />

      <WhyChooseUs />

      <ApiProducts />

      <Testimonial />

      <SignupBanner />

      <Footer />
    </React.Fragment>
  );
};

export default Home;
